import {isFeatureEnabled} from 'feature-flags';
import {openDialog} from 'platform/components';

import {isFalse} from 'ramda-adjunct';

import {
  PatchServiceCheckInApiResponse,
  PatchServiceHandOverApiResponse,
  PostServiceCheckInApiResponse,
  PostServiceHandOverApiResponse,
} from '@dms/api/workshop';
import featureFlags from '@dms/feature-flags';
import {testIds} from '@dms/routes';

import {MileageValidationDialog} from '../components/MileageValidationDialog';

// TODO: T20-135830 — once VEHICLE_MILEAGE_HISTORY is removed and the inline MileageInput warning
// becomes the default behavior, delete this opener and the MileageValidationDialog it renders
export const openMileageValidationDialogIfNeeded = (
  response:
    | PostServiceCheckInApiResponse
    | PatchServiceCheckInApiResponse
    | PostServiceHandOverApiResponse
    | PatchServiceHandOverApiResponse
) => {
  if (isFeatureEnabled(featureFlags.VEHICLE_MILEAGE_HISTORY)) {
    return;
  }

  if (!isFalse(response?.isMileageValid)) {
    return;
  }

  openDialog(
    <MileageValidationDialog
      highestMileage={response?.highestMileage}
      data-testid={testIds.workshop.serviceCaseDetail('mileageValidation')}
    />,
    {
      size: 'small',
    }
  );
};
